import IntegrationCallListResourceModel from '../../generated/types/model/resource/IntegrationCallListResourceModel';

export default class IntegrationCallListResourceViewModel extends IntegrationCallListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
